import { render, staticRenderFns } from "./PicturePopup.vue?vue&type=template&id=4b0080f2&"
import script from "./PicturePopup.vue?vue&type=script&lang=js&"
export * from "./PicturePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports